export const mapData =   [
    [
    116.48918862,
    40.1186032
],
[
    116.49006747,
    40.11733076
],
[
    116.49043375,
    40.11679856
],
[
    116.49152962,
    40.1140205
],
[
    116.4922236,
    40.11149056
],
[
    116.49241492,
    40.10914254
],
[
    116.49233439,
    40.10787022
],
[
    116.49078876,
    40.10778003
],
[
    116.4904052,
    40.10375282
],
[
    116.49011218,
    40.10270501
],
[
    116.48964335,
    40.101999
],
[
    116.48841146,
    40.10105964
],
[
    116.48704676,
    40.10005136
],
[
    116.48586686,
    40.09926789
],
[
    116.48512945,
    40.09900184
],
[
    116.48379677,
    40.09851641
],
[
    116.48263236,
    40.09762851
],
[
    116.48088379,
    40.09698202
],
[
    116.47945463,
    40.09765023
],
[
    116.4776559,
    40.09797574
],
[
    116.47626628,
    40.09756387
],
[
    116.47487496,
    40.09671316
],
[
    116.47433345,
    40.09681384
],
[
    116.4737957,
    40.0974352
],
[
    116.47334443,
    40.09750711
],
[
    116.47311504,
    40.0972626
],
[
    116.47267881,
    40.09681097
],
[
    116.47187406,
    40.09646577
],
[
    116.4700583,
    40.09566214
],
[
    116.46635313,
    40.09483907
],
[
    116.46491692,
    40.09352817
],
[
    116.46475564,
    40.09283767
],
[
    116.46500699,
    40.09239559
],
[
    116.46601282,
    40.09156438
],
[
    116.46684191,
    40.0901854
],
[
    116.46994207,
    40.08987671
],
[
    116.47101232,
    40.08939485
],
[
    116.47161926,
    40.08788924
],
[
    116.47164562,
    40.08787093
],
[
    116.47356045,
    40.08554998
],
[
    116.47507761,
    40.08496255
],
[
    116.47511611,
    40.08495901
],
[
    116.47979227,
    40.08451487
],
[
    116.48294201,
    40.08374604
],
[
    116.48339001,
    40.08324048
],
[
    116.48294141,
    40.08238027
],
[
    116.4840223,
    40.08250923
],
[
    116.48513727,
    40.08232584
],
[
    116.48570354,
    40.08199841
],
[
    116.48667474,
    40.081037
],
[
    116.48673009,
    40.08102462
],
[
    116.49211124,
    40.0806572
],
[
    116.49451132,
    40.08050098
],
[
    116.49829487,
    40.0803022
],
[
    116.4993482,
    40.08040397
],
[
    116.50113993,
    40.0793678
],
[
    116.50381929,
    40.0776123
],
[
    116.50540286,
    40.07610761
],
[
    116.50678731,
    40.07435023
],
[
    116.50842996,
    40.07307093
],
[
    116.51140612,
    40.0710826
],
[
    116.5126944,
    40.07065724
],
[
    116.51394129,
    40.07042266
],
[
    116.51494108,
    40.07045981
],
[
    116.51804356,
    40.0710753
],
[
    116.52019806,
    40.07130552
],
[
    116.52308665,
    40.07144691
],
[
    116.52599143,
    40.07133435
],
[
    116.52823245,
    40.07082529
],
[
    116.52942169,
    40.07029081
],
[
    116.53296103,
    40.0679824
],
[
    116.5344,
    40.06678311
],
[
    116.53640966,
    40.06472197
],
[
    116.53778148,
    40.06312168
],
[
    116.53873914,
    40.06224801
],
[
    116.54002185,
    40.06140629
],
[
    116.54216915,
    40.05999271
],
[
    116.54318057,
    40.05940615
],
[
    116.54530596,
    40.06094221
],
[
    116.54621362,
    40.06359223
],
[
    116.54028175,
    40.06915767
],
[
    116.54077491,
    40.06995149
],
[
    116.54030443,
    40.07018139
],
[
    116.5418953,
    40.07244856
],
[
    116.53869221,
    40.07957619
],
[
    116.54030008,
    40.07961945
],
[
    116.54342162,
    40.07962906
],
[
    116.54490276,
    40.08045441
],
[
    116.54451203,
    40.08256523
],
[
    116.54542039,
    40.08258117
],
[
    116.54853747,
    40.08340102
],
[
    116.55177751,
    40.08526958
],
[
    116.553215,
    40.08556713
],
[
    116.55379789,
    40.0848277
],
[
    116.55470041,
    40.08476441
],
[
    116.55579955,
    40.0859024
],
[
    116.55600658,
    40.08591279
],
[
    116.5573928,
    40.0874244
],
[
    116.55667932,
    40.08774684
],
[
    116.55680652,
    40.08831729
],
[
    116.55644212,
    40.08858915
],
[
    116.55674296,
    40.08873148
],
[
    116.55670469,
    40.08887441
],
[
    116.55628785,
    40.09042313
],
[
    116.55660642,
    40.09045845
],
[
    116.55619394,
    40.09208506
],
[
    116.55440291,
    40.09229321
],
[
    116.55475993,
    40.0944964
],
[
    116.55753244,
    40.09429461
],
[
    116.55731634,
    40.09279562
],
[
    116.55922318,
    40.09264655
],
[
    116.55950849,
    40.09445132
],
[
    116.56338482,
    40.09413722
],
[
    116.56445909,
    40.09656241
],
[
    116.57432816,
    40.09614059
],
[
    116.57445853,
    40.09634439
],
[
    116.57444152,
    40.09670862
],
[
    116.57443018,
    40.09782731
],
[
    116.57440752,
    40.09948736
],
[
    116.57422082,
    40.10103955
],
[
    116.57404224,
    40.10218816
],
[
    116.57348254,
    40.10517904
],
[
    116.57446973,
    40.10530391
],
[
    116.57406145,
    40.107805
],
[
    116.57553248,
    40.10793532
],
[
    116.57591867,
    40.10542701
],
[
    116.57629628,
    40.10546131
],
[
    116.57652026,
    40.10430932
],
[
    116.57740265,
    40.10429225
],
[
    116.57771461,
    40.10330459
],
[
    116.57798581,
    40.10304739
],
[
    116.5816556,
    40.10337255
],
[
    116.58175767,
    40.10281717
],
[
    116.58454413,
    40.10301798
],
[
    116.5881097,
    40.10305589
],
[
    116.58793566,
    40.10387357
],
[
    116.58864549,
    40.10395583
],
[
    116.58802168,
    40.1094179
],
[
    116.5875079,
    40.11739051
],
[
    116.58639162,
    40.12768154
],
[
    116.58639794,
    40.13098068
],
[
    116.57632518,
    40.13087626
],
[
    116.57634949,
    40.12702218
],
[
    116.57619846,
    40.12706785
],
[
    116.57462386,
    40.12754407
],
[
    116.57465017,
    40.12731267
],
[
    116.57097789,
    40.12758269
],
[
    116.57098623,
    40.12768146
],
[
    116.56468139,
    40.12765793
],
[
    116.56269828,
    40.12745357
],
[
    116.5608243,
    40.12725593
],
[
    116.56086163,
    40.12325023
],
[
    116.55721518,
    40.12291632
],
[
    116.55736463,
    40.12055363
],
[
    116.55221446,
    40.12048952
],
[
    116.55211194,
    40.122136
],
[
    116.54353464,
    40.12136996
],
[
    116.54349288,
    40.12204067
],
[
    116.5417162,
    40.12192787
],
[
    116.54070501,
    40.12460775
],
[
    116.53594852,
    40.12328658
],
[
    116.53562351,
    40.12412136
],
[
    116.53548262,
    40.12409516
],
[
    116.53311172,
    40.12366184
],
[
    116.53265868,
    40.12569879
],
[
    116.53436487,
    40.12597185
],
[
    116.53409846,
    40.12678234
],
[
    116.53301579,
    40.12663065
],
[
    116.53291943,
    40.12680401
],
[
    116.5324943,
    40.12666099
],
[
    116.53255098,
    40.12650929
],
[
    116.5312926,
    40.12622323
],
[
    116.53040573,
    40.1285923
],
[
    116.52978913,
    40.13146164
],
[
    116.52542239,
    40.13072526
],
[
    116.52457031,
    40.13346785
],
[
    116.52394977,
    40.13344504
],
[
    116.52389607,
    40.13398334
],
[
    116.52328747,
    40.13410651
],
[
    116.52271466,
    40.13414756
],
[
    116.52258936,
    40.13452163
],
[
    116.52137811,
    40.13443952
],
[
    116.52122894,
    40.13435285
],
[
    116.52037569,
    40.13424792
],
[
    116.52033989,
    40.13407457
],
[
    116.51988641,
    40.13406089
],
[
    116.51988575,
    40.13382451
],
[
    116.51992325,
    40.13308542
],
[
    116.5114963,
    40.13251907
],
[
    116.51167346,
    40.13110398
],
[
    116.51250139,
    40.13094883
],
[
    116.51259067,
    40.12908078
],
[
    116.51186826,
    40.12845395
],
[
    116.51176419,
    40.12683166
],
[
    116.51095811,
    40.12661214
],
[
    116.5087055,
    40.1243409
],
[
    116.50989805,
    40.12404539
],
[
    116.50988666,
    40.12317448
],
[
    116.50890785,
    40.12230439
],
[
    116.50695023,
    40.12067645
],
[
    116.50728058,
    40.12048933
],
[
    116.50685235,
    40.1201338
],
[
    116.50619166,
    40.11956307
],
[
    116.50599136,
    40.11873448
],
[
    116.50499507,
    40.11860563
],
[
    116.50500971,
    40.11749643
],
[
    116.50298052,
    40.1174236
],
[
    116.5011125,
    40.1179614
],
[
    116.49906747,
    40.11838602
],
[
    116.49847372,
    40.11898749
],
[
    116.49763321,
    40.11990148
],
[
    116.4972785,
    40.11997814
],
[
    116.49593675,
    40.11996635
],
[
    116.49467355,
    40.11981772
],
[
    116.49387943,
    40.11969768
],
[
    116.49279907,
    40.11914691
],
[
    116.4922912,
    40.11841961
],
[
    116.49197725,
    40.11822542
],
[
    116.49176949,
    40.11837371
],
[
    116.49129394,
    40.11850434
],
[
    116.49015818,
    40.1186491
],
[
    116.48994118,
    40.11877267
],
[
    116.48918862,
    40.1186032
]
]
